import jupiter from '../../../../resources/images/birth-chart/planets/jupiter.webp';
import mars from '../../../../resources/images/birth-chart/planets/mars.webp';
import mercury from '../../../../resources/images/birth-chart/planets/mercury.webp';
import moon from '../../../../resources/images/birth-chart/planets/moon.webp';
import neptune from '../../../../resources/images/birth-chart/planets/neptune.webp';
import northNode from '../../../../resources/images/birth-chart/planets/north-node.webp';
import pluto from '../../../../resources/images/birth-chart/planets/pluto.webp';
import saturn from '../../../../resources/images/birth-chart/planets/saturn.webp';
import sun from '../../../../resources/images/birth-chart/planets/sun.webp';
import uranus from '../../../../resources/images/birth-chart/planets/uranus.webp';
import venus from '../../../../resources/images/birth-chart/planets/venus.webp';

/** Report body key -> planet artwork. */
const PLANET_IMAGES = { sun, moon, mercury, venus, mars, jupiter, saturn, uranus, neptune, pluto, northNode };

/**
 * How much larger to draw a planet so its GLOBE matches the others.
 *
 * Every planet image fills its canvas edge to edge except Saturn, whose rings span
 * the width and whose globe is only ~220 of 512 px. Drawn at the same box size it
 * reads as a tiny planet beside the rest. Scaling the artwork keeps the globe the
 * same size as every other planet and lets the rings extend past it, centred.
 */
export const PLANET_SCALE = { saturn: 2.3 };

export default PLANET_IMAGES;
